import { gql } from "@apollo/client";
import { CancellationPolicy, Request, TermsInput } from "types";

export const SIGN_TOS_MUTATION = gql`
  mutation SignTOS($input: SignTOSInput!) {
    signTOS(input: $input) {
      success
    }
  }
`;

export interface SignTOSInput {
  request: Request;
  printedName: string;
  intro?: string[];
  terms?: TermsInput[];
  cancellationPolicies?: CancellationPolicy[];
}

export interface SignTOSResponse {
  signTOS: {
    success: boolean;
  };
}
